import { graphRoot } from "../constants/global-values";

export async function GetUserDetails(token: string, siteId: string, listId: string, email: string) {
  const res = await fetch(`${graphRoot}/sites/${siteId}/lists/${listId}/items?expand=fields`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const userlistData = await res.json();
  const matchedItem = userlistData.value?.find(
    (item: any) => item.fields?.MailAddress?.toLowerCase() === email.toLowerCase()
  );
  return {
    Role: matchedItem?.fields?.Role || null,
  };
}